export class UCSDKService {
  getTopic = (channelName, topicName) => {
    const topic = global.uc?.channels[channelName]?.topics[topicName];

    return topic;
  };

  getTopicAsync = async (channelName, topicName) => {
    await window.libraryManager?.UCSDKLibrary;
    const topic = global.uc?.channels[channelName]?.topics[topicName];

    return topic;
  };

  getB2CCookieContainerIdAsync = async () => {
    await window.libraryManager?.UCSDKLibrary;
    const cookieBannerContainerId = global.uc.b2c?.getCookieContainer();

    return cookieBannerContainerId;
  };

  findIfIsUserEligibleAsync = async featureName => {
    await window.libraryManager?.UCSDKLibrary;
    const isUserEligible = await global.uc.feature?.isUserEligible(featureName);

    return isUserEligible;
  };

  getActiveAbTestFeaturesAsync = async featureTestId => {
    await window.libraryManager?.UCSDKLibrary;
    const abTestActiveFeatures =
      await global.uc.feature?.getActiveAbTestFeatures(featureTestId);

    return abTestActiveFeatures;
  };

  checkEnvAuthPasswordAsync = async password => {
    await window.libraryManager?.UCSDKLibrary;
    const result =
      await global.uc.envAccessAuthFunctions?.checkPassword(password);
    return result;
  };

  clearNativeDataStore = async () => {
    await window.libraryManager?.UCSDKLibrary;
    global.NativeInterface?.clearNativeDataStore();
  };

  updateNativeDataStore = async () => {
    await window.libraryManager?.UCSDKLibrary;
    global.NativeInterface?.updateNativeDataStore();
  };
}
